import React from 'react'
import {
  Div,
  ListItem,
  SelectableCard,
  Spacer,
  UserCard,
} from '@sendoutcards/quantum-design-ui'
import { useQueries } from 'src/hooks'
import { getSponsors, SponsorFragment } from 'src/graphql'
import NoResultsPlaceholder from './NoResultsPlaceHolder'
import SearchForSponsorPlaceholder from './SearchForSponsorPlaceHolder'
import { formatLocation } from 'src/helpers'

const SponsorSearch = (props: {
  search: string
  selectedSponsor?: SponsorFragment
  setSelectedSponsor: (sponsor?: SponsorFragment) => void
}) => {
  const { search, selectedSponsor, setSelectedSponsor } = props
  const [filteredSponsors] = useQueries(
    search.length > 0 ? getSponsors({ search }) : undefined,
  )
  return (
    <>
      <Spacer space="x2" />
      <Div overflow="auto" width="100%">
        {filteredSponsors &&
          filteredSponsors.length > 0 &&
          filteredSponsors.map(sponsor => {
            return (
              <ListItem
                key={sponsor.id}
                orientation="vertical"
                inset={{ vertical: 'x1', horizontal: 'x0' }}
              >
                <SelectableCard
                  isActive={selectedSponsor?.id === sponsor.id}
                  onClick={() => {
                    selectedSponsor !== sponsor
                      ? setSelectedSponsor(sponsor)
                      : setSelectedSponsor(undefined)
                  }}
                >
                  <UserCard
                    profileImage={sponsor.storefront?.mugshot?.url}
                    firstName={sponsor.firstName}
                    lastName={sponsor.lastName}
                    caption={formatLocation(
                      sponsor.shippingAddress?.city,
                      sponsor.shippingAddress?.state,
                    )}
                    size="small"
                    active={selectedSponsor?.id === sponsor.id}
                  />
                </SelectableCard>
              </ListItem>
            )
          })}
        {search.length > 0 &&
          filteredSponsors &&
          filteredSponsors.length === 0 && (
            <NoResultsPlaceholder search={search} />
          )}
        {filteredSponsors === undefined && <SearchForSponsorPlaceholder />}
      </Div>
    </>
  )
}

export default SponsorSearch
